import React from "react"
import Header from '../../components/Header/'
import Footer from '../../components/Footer/'
import Form from '../Form/'
import Preview from '../Preview/'

import './fonts/style.css'
import './style.css'

class PosterGenerator extends React.Component {
    render() {
        return (
            <main>
                
                <Header />

                <div className="container" id="inhoud">
                    <div className="row">
                         <div className="form-wrap__intro">
                            <h1>Maak je eigen Zet ‘m op poster</h1>                           
                            <p>In Nederland fietsen we veel en graag, maar als fietser ben je kwetsbaar. Een fietshelm beschermt je hoofd en verkleint de kans op ernstig letsel, waardoor je veiliger en met meer vertrouwen de weg op gaat. Help mee om fietsveiligheid onder de aandacht te brengen!</p>
                            <p>Maak hieronder jouw eigen poster voor de <b>Dag van de Fietshelm 2026</b> en verspreid deze vanaf <b>15 april</b>, dé dag waarop we samen het belang van een fietshelm benadrukken.</p>
                            <p><b>Zet ‘m op!</b></p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column column--form">
                            <div className="form-wrap">
                                {/* <div className="form-wrap__intro">
                                    <h1>Maak je eigen Zet ‘m op poster</h1>                           
                                    <p>In Nederland fietsen we veel en graag, maar als fietser ben je kwetsbaar. Een fietshelm beschermt je hoofd en verkleint de kans op ernstig letsel, waardoor je veiliger en met meer vertrouwen de weg op gaat. Help mee om fietsveiligheid onder de aandacht te brengen!</p>
                                    <p>Maak hieronder jouw eigen poster voor de <b>Dag van de Fietshelm 2026</b> en verspreid deze vanaf <b>15 april</b>, dé dag waarop we samen het belang van een fietshelm benadrukken.</p>
                                    <p><b>Zet ‘m op!</b></p>
                                </div> */}
                                <div className="form-wrap__form">
                                    <Form />
                                </div>
                            </div>
                        </div>
                        <div className="column column--preview">
                            <Preview />
                        </div>
                    </div>
                    
                </div>
            
                <Footer />
            
            </main>
        )
    }
}

export default PosterGenerator